import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PendingRequestSummaryModel } from 'src/app/models/dashboard/pending-request-summary.model';
import { RequestTypeModel } from 'src/app/models/dashboard/request-type.model';
import { PersonModel } from 'src/app/models/person/person.model';
import { TableColumn } from 'src/app/models/table-column.model';
import { TrainingModel } from 'src/app/models/training/training.model';

@Component({
  selector: 'app-pending-requests-widget-demo',
  standalone: false,
  templateUrl: './pending-requests-widget-demo.component.html',
  styleUrl: './pending-requests-widget-demo.component.scss'
})
export class PendingRequestsWidgetDemoComponent {
  requests: PendingRequestSummaryModel[] = [];
  
  requestColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.TYPE'),
      dataField: 'type',
      dataType: 'string',
      disableFiltering: true,
      cellValue: (data: PendingRequestSummaryModel): string => {
        switch (data.type) {
          case RequestTypeModel.CertificateApproval:
            return data.requestsCount + ' ' + this.translateService.instant(
              'APPROVAL-REQUEST.TYPES.CERTIFICATE-APPROVALS'
            );
          case RequestTypeModel.CourseApproval:
            return data.requestsCount + ' ' + this.translateService.instant(
              'APPROVAL-REQUEST.TYPES.COURSE-APPROVALS'
            );
          case RequestTypeModel.Queue:
            return data.requestsCount + ' ' + this.translateService.instant(
              'APPROVAL-REQUEST.TYPES.QUEUE'
            );
          default:
            return 'n.a.';
        }
      },
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.REQUESTOR'),
      dataField: 'requestor',
      dataType: 'string',
      disableFiltering: false,
      cellValue: (data: PendingRequestSummaryModel): string => {
        if(data.type == RequestTypeModel.Queue) {
          return data.training?.name ?? '';
        } else {
          if(!data.requestor) return '';
          return data.requestor.firstName + ' ' + data.requestor.lastName
        }
      },
    }
  ];

  constructor(
    private translateService: TranslateService,
  ) {
    
  }

  ngOnInit() {
   const data: PendingRequestSummaryModel[] = [
      {
        id: 1,
        type: 1,
        date: new Date('2025-09-01T10:00:00Z'),
        requestsCount: 5,
        requestor: { id: 'person-987', firstName: 'Emily', lastName: 'Davis' } as PersonModel,
        training: null,
        subscription: null,
        tenantSubscription: null
      } as PendingRequestSummaryModel,
      {
        id: 2,
        type: 2,
        date: new Date('2025-09-03T14:30:00Z'),
        requestsCount: 2,
        requestor: { id: 'person-987', firstName: 'Emily', lastName: 'Davis' } as PersonModel,
        training: null,
        subscription: null,
        tenantSubscription: null
      } as PendingRequestSummaryModel,
      {
        id: 3,
        type: 1,
        date: new Date('2025-09-06T11:00:00Z'),
        requestsCount: 7,
        training: { id: 'training-123', name: 'Software Skills' } as TrainingModel,
        requestor: null,
        subscription: null,
        tenantSubscription: null
      } as PendingRequestSummaryModel,
    ];
    this.requests = data;
  }
}
